import styled from "styled-components"

export interface StyledSectionProps {
  background_color: string
}

export const StyledSection = styled.section<StyledSectionProps>`
  padding: 64px 0;

  width: 100%;
  // max-width: ${(props) => props.theme.breakPoints.max};
  margin: 0 auto;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 48px 0;
  }
  background: ${(props) =>
    props.background_color === "white" && props.theme.colors.white};
  background: ${(props) =>
    props.background_color === "ivory" && props.theme.colors.ivory};
  background: ${(props) =>
    props.background_color === "ivory_dark" && props.theme.colors.ivoryShadow};
  background: ${(props) =>
    props.background_color === "light_pink" && props.theme.colors.pinkLight};
  background: ${(props) =>
    props.background_color === "pink" && props.theme.colors.pink};
  background: ${(props) =>
    props.background_color === "dark_pink" && props.theme.colors.pinkDark};
  background: ${(props) =>
    props.background_color === "light_green" && props.theme.colors.greenLight};
  background: ${(props) =>
    props.background_color === "green" && props.theme.colors.green};
  background: ${(props) =>
    props.background_color === "dark_green" && props.theme.colors.greenDark};
  background: ${(props) =>
    props.background_color === "light_blue" && props.theme.colors.blueLight};
  background: ${(props) =>
    props.background_color === "blue" && props.theme.colors.blue};
  background: ${(props) =>
    props.background_color === "dark_blue" && props.theme.colors.blueDark};
`

export const StyledSectionContainer = styled.div`
  ${(props) => props.theme.mixins.container};
  position: relative;
  z-index: 1;
`

export const StyledSectionTitle = styled.div`
  border-top: 2px solid ${(props) => props.theme.colors.darkGrey};
  padding-top: 8px;
  display: flex;
  align-items: center;
  /* margin-bottom: 32px; */

  > img {
    max-height: 36px;
    max-width: 36px;
    margin-right: 16px;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin-bottom: 16px;
  }
`

export const StyledSectionHeading = styled.h2`
  font-family: ${(props) => props.theme.fonts.circularBook};
  color: ${(props) => props.theme.colors.darkGrey};
  text-transform: uppercase;
  font-size: 28px;
  margin: 0;
  line-height: 28px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 22px;
    line-height: 26px;
  }
`
export const StyledSectionDescription = styled.p`
  padding-top: 32px;
  font-size: 26px;
  line-height: 30px;
  color: ${(props) => props.theme.colors.darkGrey};
  max-width: 786px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
  }
`

export const StyledSectionBody = styled.div``

export const StyledSectionHeader = styled.header`
  display: flex;
  flex-direction: column;
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    display: flex;
    justify-content: space-between;
  }

  & + ${StyledSectionBody} {
    margin-top: 32px;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      margin-top: 24px;
    }
  }
`
